import React from 'react'
import { FooterNavStyle, FooterNavBtnIcon, FooterNavBtnText } from './style'
import { ButtonBorder, ButtonFull } from 'components/Form/Button'
import config from 'configs/config'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Button, PriceStrong, Text } from '../../style'
import { formatPrice, stopPropagation } from 'utils/common'
import { useSwipeable } from 'react-swipeable'
import { Icon } from '../../../Icon'
import { useSelector } from 'react-redux'
import { LoaderSpinner } from '../../../Loader'
import AnimatedNumber from 'react-animated-number'

const FooterNav = ({
	isOpen,
	continueUrl,
	partialRequestData,
	flowStep,
	backUrl,
	totals,
	quantityItem,
	setIsOpen,
	getCartFinal,
	getSpecificAction,
	isContinueActive,
	currency,
}) => {
	const handlers = useSwipeable({
		onSwipedUp: () => {
			if (!isOpen) setIsOpen(true)
		},
	})
	const { isLoading } = useSelector((state) => state.steps)
	return (
		<FooterNavStyle {...handlers}>
			<div onClick={stopPropagation}>
				<ButtonBorder
					disabled={flowStep === config.flowSteps.SELECT}
					as={Link}
					to={backUrl}
					uppercase='true'
					className='buttonBack'
					isnavbtn='true'
				>
					<FooterNavBtnIcon left>
						<Icon className='icon-left' component='arrowDown' />
					</FooterNavBtnIcon>
					<FooterNavBtnText
						disabled={flowStep === config.flowSteps.SELECT}
					>
						<FormattedMessage
							id='cart.button.back.label'
							defaultMessage='Back'
						/>
					</FooterNavBtnText>
				</ButtonBorder>
			</div>
			<div className='flex-auto'>
				<Text>
					<FormattedMessage
						id='cart.expanded.differencePositive'
						defaultMessage='Return Value Available'
					/>
					:{' '}
					<PriceStrong>
						<AnimatedNumber
							value={totals.refundTotal}
							duration={
								config.numbersAnimation.numberAnimationDuration
							}
							stepPrecision={
								config.numbersAnimation.numberStepPrecision
							}
							formatValue={(n) => {
								return formatPrice(n, currency)
							}}
						/>
					</PriceStrong>
					<div>
						{quantityItem === 1 ? (
							<FormattedMessage
								id='cart.collapsed.chosen.goods.count.single'
								defaultMessage='(Returning {itemsCount} product)'
								values={{
									itemsCount: (
										<AnimatedNumber
											value={quantityItem}
											duration={
												config.numbersAnimation
													.numberAnimationDuration
											}
											stepPrecision={
												config.numbersAnimation
													.numberStepPrecision
											}
										/>
									),
								}}
							/>
						) : quantityItem > 1 ? (
							<FormattedMessage
								id='cart.collapsed.chosen.goods.count.multiple'
								defaultMessage='(Returning {itemsCount} product)'
								values={{
									itemsCount: (
										<AnimatedNumber
											value={quantityItem}
											duration={
												config.numbersAnimation
													.numberAnimationDuration
											}
											stepPrecision={
												config.numbersAnimation
													.numberStepPrecision
											}
										/>
									),
								}}
							/>
						) : (
							''
						)}
					</div>
				</Text>
			</div>
			<div onClick={stopPropagation}>
				{isContinueActive() ? (
					<>
						{flowStep === config.flowSteps.REFUND ? (
							isLoading ? (
								<ButtonFull
									uppercase='true'
									as={Button}
									onClick={() => {}}
									isnavbtn='true'
									disabled={true}
									isLoading={true}
									className='buttonNext'
								>
									<FooterNavBtnIcon right>
										<Icon
											className='icon-left'
											component='arrowDown'
										/>
									</FooterNavBtnIcon>
									<FooterNavBtnText disabled={true}>
										<FormattedMessage
											id={'cart.expanded.button.confirm'}
											defaultMessage='Continue'
										/>
									</FooterNavBtnText>
									<LoaderSpinner
										isActive={true}
										isBtnLoader={true}
									/>
								</ButtonFull>
							) : (
								<ButtonFull
									uppercase='true'
									as={Button}
									onClick={() => {
										getCartFinal(partialRequestData)
									}}
									isnavbtn='true'
									disabled={isLoading ? true : false}
									className='buttonNext'
								>
									<FooterNavBtnIcon right>
										<Icon
											className='icon-left'
											component='arrowDown'
										/>
									</FooterNavBtnIcon>
									<FooterNavBtnText
										disabled={isLoading ? true : false}
									>
										<FormattedMessage
											id={'cart.expanded.button.confirm'}
											defaultMessage='Continue'
										/>
									</FooterNavBtnText>
								</ButtonFull>
							)
						) : isLoading ? (
							<ButtonFull
								uppercase='true'
								as={Button}
								isnavbtn='true'
								disabled={true}
								isLoading={true}
								className='buttonNext'
							>
								<FooterNavBtnIcon right>
									<Icon
										className='icon-left'
										component='arrowDown'
									/>
								</FooterNavBtnIcon>
								<FooterNavBtnText disabled={true}>
									<FormattedMessage
										id={'orders.continue.button'}
										defaultMessage='Continue'
									/>
								</FooterNavBtnText>
								<LoaderSpinner
									isActive={true}
									isBtnLoader={true}
								/>
							</ButtonFull>
						) : (
							<ButtonFull
								uppercase='true'
								as={Link}
								to={continueUrl}
								isnavbtn='true'
								disabled={isLoading ? true : false}
								className='buttonNext'
							>
								<FooterNavBtnIcon right>
									<Icon
										className='icon-left'
										component='arrowDown'
									/>
								</FooterNavBtnIcon>
								<FooterNavBtnText
									disabled={isLoading ? true : false}
								>
									<FormattedMessage
										id={'orders.continue.button'}
										defaultMessage='Continue'
									/>
								</FooterNavBtnText>
							</ButtonFull>
						)}
					</>
				) : isLoading ? (
					<ButtonFull
						uppercase='true'
						as={Button}
						disabled={true}
						isnavbtn='true'
						onClick={() => {}}
						className='buttonNext'
					>
						<FooterNavBtnIcon right>
							<Icon className='icon-left' component='arrowDown' />
						</FooterNavBtnIcon>
						<FooterNavBtnText disabled={true}>
							<FormattedMessage
								id={'orders.continue.button'}
								defaultMessage='Continue'
							/>
						</FooterNavBtnText>
					</ButtonFull>
				) : (
					<ButtonFull
						uppercase='true'
						as={Button}
						disabled={
							flowStep === config.flowSteps.RETURN ||
							flowStep === config.flowSteps.COMPLAINT
								? false
								: true
						}
						isnavbtn='true'
						onClick={() => {
							getSpecificAction()
						}}
						className='buttonNext'
					>
						<FooterNavBtnIcon right>
							<Icon className='icon-left' component='arrowDown' />
						</FooterNavBtnIcon>
						<FooterNavBtnText
							disabled={
								flowStep === config.flowSteps.RETURN ||
								flowStep === config.flowSteps.COMPLAINT
									? false
									: true
							}
						>
							<FormattedMessage
								id={'orders.continue.button'}
								defaultMessage='Continue'
							/>
						</FooterNavBtnText>
					</ButtonFull>
				)}
			</div>
		</FooterNavStyle>
	)
}
export default FooterNav
